import React from 'react';

interface InlineFormProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  description?: string;
  childrenClassNames?: string;
}

const InlineForm: React.FC<InlineFormProps> = ({
  title,
  description,
  children,
  childrenClassNames = '',
}) => (
  <div className="flex w-full flex-col lg:flex-row">
    <div className="w-full lg:w-96">
      <div className="prose-body-md-med">{title}</div>
      <div className="prose-body-sm-reg text-kira-slate-700">{description}</div>
    </div>
    <div className={`flex-1 lg:pl-12 ${childrenClassNames}`}>{children}</div>
  </div>
);
export default InlineForm;
